export default [
  {
    name: 'serialNumber',
    label: 'Serial number (Format: ##/###,###)',
    validation: 'optional|matches:/^[0-9]{2}/[0-9]{3}.[0-9]{3}$/',
    validationMessages: {
      matches: 'Serial number should be in this format: ##/###,###'
    }
  },
  {
    name: 'filingDate',
    label: 'Filing Date',
    type: 'date'
  },
  {
    component: 'h4',
    name: 'draft-document-label',
    children: 'Draft Document'
  },
  {
    name: 'draft',
    label: 'Upload a document',
    type: 'file'
  },
  {
    name: 'draftFeedback',
    label: 'Draft Feedback',
    type: 'textarea'
  },
  {
    component: 'h4',
    name: 'as-filed-label',
    children: 'As-Filed Patent Application'
  },
  {
    name: 'asFiled',
    label: 'Upload a document',
    type: 'file',
  },
  {
    component: 'h4',
    name: 'filing-receipt-label',
    children: 'Filing Receipt'
  },
  {
    name: 'filingReceipt',
    label: 'Upload a document',
    type: 'file',
  },
]